"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("./InputTextArea.scss");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactTextMask = require("react-text-mask");

var _reactTextMask2 = _interopRequireDefault(_reactTextMask);

var _colors = require("../../../constants/colors");

var _InputErrorMessage = require("../InputErrorMessage");

var _InputErrorMessage2 = _interopRequireDefault(_InputErrorMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var rootClass = 'c-InputTextArea';

var InputTextArea =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(InputTextArea, _PureComponent);

  function InputTextArea(props) {
    var _this;

    _classCallCheck(this, InputTextArea);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputTextArea).call(this, props));
    _this.InputRef = void 0;

    _this.handleOnFocus = function () {
      _this.setState({
        focus: true
      });
    };

    _this.handleOnBlur = function (e) {
      _this.setState({
        focus: false
      });

      if (_this.props.onBlur !== undefined) {
        _this.props.onBlur(e);
      }
    };

    _this.getErrorClass = function () {
      return _this.props.error ? "".concat(rootClass, "--error") : '';
    };

    _this.getDisabledClass = function () {
      return _this.props.disabled ? "".concat(rootClass, "--disabled") : '';
    };

    _this.getFocusClass = function () {
      return _this.state.focus ? "".concat(rootClass, "--focused") : '';
    };

    _this.getPrefix = function () {
      return _this.props.prefix ? _react2.default.createElement("span", {
        className: "".concat(rootClass, "__prefix"),
        "data-testid": "input-prefix",
        onClick: _this.focusInput
      }, _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _this.props.prefix,
        color: _colors.doveGrayColor
      })) : null;
    };

    _this.focusInput = function () {
      var input = _this.InputRef.current;

      if (input !== null) {
        input.focus();
      }
    };

    _this.getSuffix = function () {
      return _this.props.suffix ? _react2.default.createElement("span", {
        className: "".concat(rootClass, "__suffix"),
        "data-testid": "input-suffix",
        onClick: _this.focusInput
      }, _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _this.props.suffix,
        color: _colors.doveGrayColor
      })) : null;
    };

    _this.state = {
      focus: false
    };
    _this.InputRef = _react2.default.createRef();
    return _this;
  }

  _createClass(InputTextArea, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autoComplete = _this$props.autoComplete,
          disabled = _this$props.disabled,
          error = _this$props.error,
          errorMessage = _this$props.errorMessage,
          placeholder = _this$props.placeholder,
          type = _this$props.type,
          name = _this$props.name,
          onChange = _this$props.onChange,
          value = _this$props.value,
          masked = _this$props.masked,
          mask = _this$props.mask,
          pipe = _this$props.pipe,
          pattern = _this$props.pattern,
          readOnly = _this$props.readOnly,
          row = _this$props.row,
          column = _this$props.column;
      var activeClasseNames = [rootClass, this.getErrorClass(), this.getDisabledClass(), this.getFocusClass()].filter(Boolean).join(' ');
      var inputProps = {
        autoComplete: autoComplete,
        tabIndex: '0',
        className: "".concat(rootClass, "__input"),
        placeholder: placeholder,
        name: name,
        id: name,
        type: type,
        value: value,
        disabled: disabled,
        onChange: onChange,
        onFocus: this.handleOnFocus,
        onBlur: this.handleOnBlur,
        readOnly: readOnly,
        pattern: pattern
      };
      return _react2.default.createElement("div", null, _react2.default.createElement(_InputErrorMessage2.default, {
        id: "".concat(name, "ErrorMessage"),
        error: error,
        errorMessage: errorMessage
      }), _react2.default.createElement("div", {
        className: activeClasseNames
      }, this.getPrefix(), masked ? _react2.default.createElement(_reactTextMask2.default, _extends({
        mask: mask,
        pipe: pipe,
        ref: this.InputRef
      }, inputProps)) : _react2.default.createElement("textarea", _extends({
        ref: this.InputRef
      }, inputProps, {
        rows: row,
        cols: column
      })), this.getSuffix()));
    }
  }]);

  return InputTextArea;
}(_react.PureComponent);

InputTextArea.defaultProps = {
  error: false,
  disabled: false,
  placeholder: '',
  type: 'text',
  id: null,
  row: '5',
  column: '5'
};
exports.default = InputTextArea;